var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('masonry',{staticClass:"masonry-container",attrs:{"cols":Object.assign({}, _vm.cols),"gutter":{
        default: '25px',
        1300: '25px',
        900: '2.5vw',
        600: '3vw',
        599: '15px'
    }}},_vm._l((_vm.images),function(image,index){return _c('div',{key:'picture-' + index,staticClass:"gallery__image"},[_c('a',{attrs:{"id":'picture-' + (index + 1)}}),_c('img',{attrs:{"src":image.url,"alt":image.title,"title":image.title}}),(_vm.showDescription)?_c('p',[_vm._v(_vm._s(image.title))]):_vm._e()])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }